var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 102,
    viewBox: "0 0 129 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 47889"
  }, /*#__PURE__*/React.createElement("g", {
    id: 17
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M118.4 50.9001C118.4 65.1001 112.6 77.9001 103.3 87.1001C94.2 96.2001 81.6 101.7 67.7 101.7C53.9 101.7 41.3 96.1001 32.1 87.1001C22.8 77.9001 17 65.1001 17 50.9001C17 22.8001 39.7 0.100098 67.7 0.100098C95.7 0.100098 118.4 22.9001 118.4 50.9001Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M103.3 24.3003V87.1003C94.2 96.2003 81.6 101.7 67.7 101.7C53.9 101.7 41.3 96.1003 32.1 87.1003V24.3003H103.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    filter: "url(#filter0_d_684_13270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.9578 56.3537L55.0279 42.4238L50.2903 47.1614L64.2202 61.0913L68.9578 56.3537Z",
    fill: "url(#paint0_linear_684_13270)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    filter: "url(#filter1_d_684_13270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.3833 35.4989L59.5946 56.2876L64.3322 61.0252L85.1209 40.2364L80.3833 35.4989Z",
    fill: "url(#paint1_linear_684_13270)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M85.9 69.6001H49.5V74.2001H85.9V69.6001Z",
    fill: "#D5DAE5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M85.9 79.7002H49.5V84.3002H85.9V79.7002Z",
    fill: "#D5DAE5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M77 89.8999H58.4V94.4999H77V89.8999Z",
    fill: "#D5DAE5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 47547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M127.123 37.9711L128.371 37.4162C128.787 37.2775 128.787 36.7226 128.371 36.5838L127.123 36.0289C125.598 35.3353 124.351 34.0867 123.657 32.5607L123.103 31.3121C122.964 30.896 122.41 30.896 122.271 31.3121L121.717 32.5607C121.023 34.0867 119.776 35.3353 118.251 36.0289L117.003 36.5838C116.587 36.7226 116.587 37.2775 117.003 37.4162L118.251 37.9711C119.776 38.6648 121.023 39.9133 121.717 41.4393L122.271 42.6879C122.41 43.1041 122.964 43.1041 123.103 42.6879L123.657 41.4393C124.212 39.9133 125.46 38.6648 127.123 37.9711Z",
    fill: "#FF7E00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M118.035 57.9829L118.867 57.5667C119.144 57.4279 119.144 57.1505 118.867 57.0118L118.035 56.7343C116.926 56.3181 116.095 55.4857 115.679 54.3759L115.263 53.5435C115.124 53.2661 114.847 53.2661 114.708 53.5435L114.431 54.3759C113.877 55.4857 113.045 56.3181 112.074 56.7343L111.104 57.1505C110.965 57.1505 110.965 57.5667 111.104 57.5667L111.936 57.9829C113.045 58.399 113.877 59.2314 114.431 60.3412L114.847 61.1736C114.986 61.4511 115.263 61.4511 115.401 61.1736L115.679 60.3412C116.095 59.2314 116.926 58.399 118.035 57.9829Z",
    fill: "#C2C8D6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 47569"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M10.4318 77.3647L11.6795 76.8098C12.0954 76.671 12.0954 76.1161 11.6795 75.9774L10.4318 75.4225C8.90691 74.7288 7.65925 73.4803 6.96611 71.9543L6.41159 70.7057C6.27296 70.2895 5.71844 70.2895 5.57982 70.7057L5.0253 71.9543C4.33215 73.4803 3.08449 74.7288 1.55958 75.4225L0.311915 75.9774C-0.103972 76.1161 -0.103972 76.671 0.311915 76.8098L1.55958 77.3647C3.08449 78.0583 4.33215 79.3069 5.0253 80.8329L5.57982 82.0814C5.71844 82.4976 6.27296 82.4976 6.41159 82.0814L6.96611 80.8329C7.52062 79.3069 8.76828 78.0583 10.4318 77.3647Z",
    fill: "#FF7E00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M10.9345 15.3632L11.7663 14.947C12.0435 14.8083 12.0435 14.5309 11.7663 14.3921L10.9345 14.1147C9.82547 13.6985 8.99369 12.8661 8.57781 11.7563L8.16192 10.9239C8.02329 10.6465 7.74603 10.6465 7.6074 10.9239L7.33014 11.7563C6.77563 12.8661 5.94386 13.6985 4.97345 14.1147L4.00305 14.5309C3.86442 14.5309 3.86442 14.947 4.00305 14.947L4.83482 15.3632C5.94386 15.7794 6.77563 16.6118 7.33014 17.7216L7.74603 18.554C7.88466 18.8314 8.16192 18.8314 8.30055 18.554L8.57781 17.7216C8.99369 16.6118 9.82547 15.7794 10.9345 15.3632Z",
    fill: "#FF7E00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M21.6085 5.57226L22.3016 5.29481C22.4402 5.15608 22.4402 5.01735 22.3016 4.87862L21.6085 4.60116C20.7767 4.32371 20.2222 3.63006 19.8063 2.79769L19.529 2.10405C19.3904 1.96532 19.2518 1.96532 19.1131 2.10405L18.8359 2.79769C18.5586 3.63006 17.8655 4.18498 17.0337 4.60116L16.6178 4.87862C16.3406 5.01735 16.3406 5.29481 16.6178 5.29481L17.311 5.57226C18.1427 5.84972 18.6973 6.54336 19.1131 7.37574L19.3904 8.06938C19.529 8.20811 19.6677 8.20811 19.8063 8.06938L20.0835 7.37574C20.2222 6.54336 20.9153 5.84972 21.6085 5.57226Z",
    fill: "#C2C8D6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_684_13270",
    x: 46.2903,
    y: 42.4238,
    width: 26.6674,
    height: 28.6675,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.352941 0 0 0 0 0.486275 0 0 0 0 0.937255 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_684_13270"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_684_13270",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_684_13270",
    x: 55.5946,
    y: 35.499,
    width: 33.5263,
    height: 35.5264,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.352941 0 0 0 0 0.486275 0 0 0 0 0.937255 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_684_13270"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_684_13270",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_684_13270",
    x1: 56.4924,
    y1: 45.1804,
    x2: 52.4165,
    y2: 53.4577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ED259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53C28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_684_13270",
    x1: 63.3904,
    y1: 53.7838,
    x2: 71.4341,
    y2: 58.8417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ED259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53C28C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignSuccess);
export default __webpack_public_path__ + "static/media/assignSuccess.ccc98f835d77c63accd3a203066cc0bf.svg";
export { ForwardRef as ReactComponent };